// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { maxQtyValue } from "@bg/XDL/Utilities/inputValidation";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ChangeProductQtyForExistingProduct,
} from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/AddProduct";

export const XngChangeProductQtyForExistingProduct: typeof ChangeProductQtyForExistingProduct = props => {
    const quickOrderProductInfos = props.getState().pages.quickOrder.productInfos;
    const { productId, qtyOrdered, unitOfMeasure } = props.productInfo;
    const existingProductInfo = quickOrderProductInfos.find(
        o => o.productId === productId && o.unitOfMeasure === unitOfMeasure,
    );
    if (!existingProductInfo) {
        return;
    }

    // XNG-Changes: if the sum of quantities greater than or equal to maxQtyValue then add the max value of 999,999
    if (existingProductInfo.qtyOrdered + qtyOrdered >= maxQtyValue) {
        props.productInfo.qtyOrdered = maxQtyValue;
    } else {
        props.productInfo.qtyOrdered = existingProductInfo.qtyOrdered + qtyOrdered;
    }
};

replaceInChain(chain, ChangeProductQtyForExistingProduct, XngChangeProductQtyForExistingProduct);
